<template>
  <div class="">
    <emails-edit> </emails-edit>
  </div>
</template>

<script>
import EmailsEdit from "@/components/profile/lisacomunica/emails/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EmailsEdit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Emails",
        path: "lisacomunica_template",
        tab: "Emails",
        level: 3,
      });
      bcs.push({
        text: "Modifica template email",
        path: "emails.edit",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Emails",
        path: "lisacomunica_template",
        tab: "Emails",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica template email",
        path: "emails.edit",
        level: 4,
      });
    }
  },
};
</script>
